/**
 * Route-level fade + slide-up wrapper. Applied inside DashLayout's <main>
 * so every dashboard page gets a subtle, consistent entry animation.
 *
 * Uses Framer Motion + `useLocation` keys so route changes trigger a fresh
 * mount. Respects `prefers-reduced-motion`.
 */
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function PageTransition({ children, className = "" }) {
  const loc = useLocation();
  return (
    <motion.div
      key={loc.pathname}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
